import { LOGOUT_FAILED_MESSAGE } from '@/lib/api';
import { retrySignOut } from '@/lib/sign-out';
import { useSignOutStore } from '@/lib/sign-out-state';

/**
 * Desfecho do "Sair" na tela de login (revisão E16 da C8). A memória já foi limpa e a sessão não
 * volta sozinha; se a API não confirmou o `/logout`, o cookie pode seguir vivo no navegador, e o
 * operador vê o erro e tenta de novo.
 */
export function SignOutStatus() {
  const status = useSignOutStore((s) => s.status);

  if (status === 'pending') {
    return (
      <div className="info-banner" role="status">
        Encerrando a sessão no servidor…
      </div>
    );
  }

  if (status !== 'failed') return null;

  return (
    <div className="error-banner" role="alert">
      <div>{LOGOUT_FAILED_MESSAGE}</div>
      <button
        type="button"
        className="btn btn-secondary btn-sm"
        style={{ marginTop: 8 }}
        onClick={() => void retrySignOut()}
      >
        Tentar sair de novo
      </button>
    </div>
  );
}
